export const T27 = {
    "columns": 6,
    "rows": 3,
    "visual": {
        "id": 1,
        "type": "bar",
        "title": "Customer Group Sales",
        "colorTheme": 'colorTheme2',
        "orientation": "horizontal",
        "xAxis": "Sales",
        "yAxis": "",
        "binding": {
            "data": {
                "series": [
                    {
                        "name": 'Sales',
                        "value": 'ActualSales',
                        "type": 'column'
                    }
                ],
                "title": "CustomerGroup",
                "endpoint": "T27",
                "parameters": [
                    { "key": "FromMonth", "value": "" },
                    { "key": "FromYear", "value": "" },
                    { "key": "ToMonth", "value": "" },
                    { "key": "ToYear", "value": "" },
                    { "key": "AgentCode", "value": "" },
                    { "key": "ConfigTypeCode", "value": "" }
                ]
            },
            "context": {
                "point": {
                    "onClick": {
                        "selectedValueColumn": "CustomerGroup",
                        "selectedTitle": "Product",
                        "visual": [
                            {
                                "columns": 12,
                                "rows": 3,
                                "visual": {
                                    "id": 1,
                                    "type": "bar",
                                    "title": "Products",
                                    "colorTheme": 'colorTheme2',
                                    "orientation": "horizontal",
                                    "xAxis": "Sales",
                                    "yAxis": "",
                                    "binding": {
                                        "data": {
                                            "series": [
                                                {
                                                    "name": 'Sales',
                                                    "value": 'ActualSales',
                                                    "type": 'column'
                                                }
                                            ],
                                            "title": "ItemName",
                                            "endpoint": "T27.1",
                                            "parameters": [
                                                { "key": "FromMonth", "value": "" },
                                                { "key": "FromYear", "value": "" },
                                                { "key": "ToMonth", "value": "" },
                                                { "key": "ToYear", "value": "" },
                                                { "key": "AgentCode", "value": "" },
                                                { "key": "CustomerGroup", "value": "" },
                                                { "key": "ConfigTypeCode", "value": "" }
                                            ]
                                        },
                                        "context": {
                                            "point": {
                                                "onClick": {

                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        ]
                    }
                }
            }
        }
    }
}